<template>
  <TableCell :style="{ background: tag.cellColor.value }"
    :tag="tag"
    :popoverTitle="popoverTitle_"
    :popoverDisabled="popoverDisabled"
    :showingPopover="showingPopover"
    :selectedCells="selectedCells"
    @update:showingPopover="value => $emit('update:showingPopover', value)"
    @update:columnSelectionCode="value => $emit('update:columnSelectionCode', value)"
  >
    {{ tag.cellText.value }}
    <template #PopoverContentDesktop>
      <div style="max-width: 550px; display: flex; flex-direction: column; justify-content: center; gap: 20px;">
        <div style="display: flex; align-items: center;">
          <div style="flex-grow: 1; flex-basis: 0;"></div>
          <h3>
            {{ popoverTitle_ }}
          </h3>
          <div style="flex-grow: 1; flex-basis: 0; text-align: right;">
            <i class="pi pi-times" style="float: right; color: gray; margin: 5px; margin-left: 30px;" @click="closePopover()"></i>
          </div>
        </div>
        <div v-if="popoverText" class="popover-button--text" v-html="popoverText"></div>
        <div style="display: flex; align-items: center; justify-content: center; gap: 20px;">
          <slot name="BinSelectionInput"></slot>
          <Button v-if="tag.buttonText.value != ''" severity="secondary" @mousedown="clickHandler()">
            {{ tag.buttonText.value }}
          </Button>
        </div>
      </div>
    </template>
  </TableCell>
</template>

<script>
import router from "./router.js";
import Checkbox from "./Checkbox.vue";
import TableCell from "./TableCell.vue";
import { getBoardHostname } from "./appUtility";

export default {
  components: { TableCell, Checkbox },
  props: [
    "tag",
    "popoverTitle",
    "showingPopover",
    "applyToAllColumnsEnabled",
    "columnSelectionCode",
    "selectedCells",
  ],
  computed: {
    popoverClass() {
      return {
        "popover-button-popover": true,
        "has-popover-text":  (this.tag.popoverText.value != "")
      };
    },
    popoverDisabled() {
      return (
        this.tag.buttonText.value == "" &&
        this.tag.popoverText.value == ""
      );
    },
    popoverTitle_() {
      if (this.tag.popoverText.value.startsWith("title:"))
        return this.tag.popoverText.value.slice(6);
      else
        return this.popoverTitle;
    },
    popoverText() {
      if (this.tag.popoverText.value.startsWith("title:"))
        return "";
      else
        return this.tag.popoverText.value;
    }
  },
  methods: {
    closePopover() {
      this.$emit("update:showingPopover", false);
    },
    clickHandler() {
      this.closePopover();

      let buttonHandler = this.tag.buttonHandler.value;
      if (buttonHandler.startsWith("url:")) {
        let url = buttonHandler.slice(4);
        let targetSystem = this.tag.$session.system;
        let thisSystem = store.sessions[0].system;
        if (targetSystem == thisSystem) {
          router.push(url.replace("{boardHostname}/", ""));
        }
        else {
          let board = thisSystem.boardsOnSite.children.find(board => board.boardId.value == targetSystem.publicKey.value);
          window.location = "http://" + url.replace("{boardHostname}", getBoardHostname(board));
        }
      }
      else {
        this.selectedCells.forEach(cell => {
          let binNumber = null;
          let tag = cell.componentArgs.tag;
          let session = tag.$session;
          if (!this.applyToAllBins) {
            let parents = tag.$parents();
            let bins = session.system.bins.children;
            binNumber = bins.findIndex(bin => parents.includes(bin));
          }
          // TODO: Fix that the 'committed' field on adjacent cells is not being toggled.
          tag.committed = false;
          session.queueRequest(this.tag.buttonHandler.value, {binNumber});
          session.pollApp(() => tag.committed = true);
        });
      }
    }
  }
}
</script>

<style>
.popover-button-popover {
  display: flex;
  flex-direction: column;
  margin-top: 3px; 
  padding: 10px;
  gap: 20px;
  max-width: 493px;
  box-sizing: border-box;
  background: whitesmoke;
  border: 1px solid black;
  border-radius: 3px;
  box-shadow: 0 3px 3px rgba(0,0,0,.12), 0 3px 2px rgba(0,0,0,.24);
}
.popover-button--text ul { 
  padding: 10px;
  padding-left: 30px;
  padding-right: 30px;
  list-style: initial;
}

.popover-button-popover label.checkbox {
  font-size: large;
}
</style>